import {FooterData} from '../disclosureData'
import React from 'react'
import styles from './Footer.module.scss'

const Footer = () => {
  return <div className={styles.Footer}><div className={styles.text} dangerouslySetInnerHTML={{__html: FooterData}} /></div>
}
export default Footer
